import { render } from "./Verify.vue?vue&type=template&id=39664c86&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=39664c86&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39664c86"]])

export default __exports__